import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import Forex from "../../images/forex.png";

const ForexRates = () => {
  const ForexRatesDocs = {
    title: "View Forex Rates",
    description:
      "Forex rates are updated regularly to show current rates for Ghana, Nigeria, and South Africa.",

    sections: [
      {
        title: "Overview",
        content:
          "This section provides the current forex rates for different currencies.",
        image: Forex,
        imageAlt: "Forex Rates",
        imageCaption: "Figure 1: Comprehensive view of daily forex rates",
      },
      {
        title: "Ghana",
        content: "Current forex rates for Ghanaian Cedi (GHS).",
      },
      {
        title: "Nigeria",
        content: "Current forex rates for Nigerian Naira (NGN).",
      },
      {
        title: "South Africa",
        content: "Current forex rates for South African Rand (ZAR).",
      },
    ],
  };

  return <FeatureDocumentation {...ForexRatesDocs} />;
};

export default ForexRates;
